import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ExternalLink, Lock, Sparkles } from "lucide-react";

const TAGS = ["All", "Free", "Student", "Discount", "Premium", "Trial"];

export default function Perks() {
  const { user } = useAuth();
  const [perks, setPerks] = useState([]);
  const [tag, setTag] = useState("All");

  useEffect(() => { api.get("/perks").then(({ data }) => setPerks(data)); }, []);

  const filtered = tag === "All" ? perks : perks.filter(p => p.tag === tag);

  return (
    <div data-testid="perks-page">
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Perks & Rewards</h1>
      <p className="text-white/60 mt-1.5">Real discounts and free resources from trusted Aussie partners.</p>

      <div className="flex flex-wrap gap-2 mt-6">
        {TAGS.map(t => (
          <button key={t} onClick={() => setTag(t)} data-testid={`perk-tag-${t}`}
            className={`px-4 py-1.5 rounded-full text-xs font-bold transition ${
              tag === t ? "bg-neoncyan text-ink shadow-glowcyan" : "bg-white/5 text-white/70 border border-white/10"
            }`}>{t}</button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-7">
        {filtered.map(p => {
          const locked = p.points_required > 0 && (user.xp || 0) < p.points_required;
          return (
            <div key={p.perk_id} className={`glass-card overflow-hidden ${locked ? "opacity-70" : ""}`} data-testid={`perk-card-${p.perk_id}`}>
              <div className="aspect-[16/9] relative overflow-hidden">
                {p.image && <img src={p.image} alt={p.title} className="w-full h-full object-cover"/>}
                <div className="absolute inset-0 bg-gradient-to-t from-ink to-transparent"/>
                {p.tag && <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-neonpink text-white text-xs font-bold">{p.tag}</span>}
                {locked && (
                  <div className="absolute inset-0 flex items-center justify-center bg-ink/70">
                    <div className="text-center">
                      <Lock className="mx-auto" size={20}/>
                      <div className="text-xs mt-1">Unlock at {p.points_required} XP</div>
                    </div>
                  </div>
                )}
              </div>
              <div className="p-5">
                <div className="text-xs text-neoncyan font-bold tracking-widest uppercase">{p.partner}</div>
                <div className="font-display font-bold text-base mt-1">{p.title}</div>
                <div className="text-sm text-white/65 mt-1.5 line-clamp-2">{p.description}</div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-white/50">{p.category}</span>
                  <a href={locked ? undefined : p.url} target="_blank" rel="noopener noreferrer"
                    onClick={e => locked && e.preventDefault()}
                    data-testid={`perk-claim-${p.perk_id}`}
                    className={locked ? "btn-secondary-neon text-xs cursor-not-allowed" : "btn-primary-neon text-xs flex items-center gap-1"}>
                    {locked ? "Locked" : <>Claim <ExternalLink size={12}/></>}
                  </a>
                </div>
              </div>
            </div>
          );
        })}
        {filtered.length === 0 && (
          <div className="col-span-full glass-card p-8 text-center text-white/60">
            <Sparkles className="mx-auto text-neonyellow mb-2"/> No perks in this category yet.
          </div>
        )}
      </div>
    </div>
  );
}
